import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { SupplierAccountStatus } from 'src/app/shared/models/enums.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deactivate-supplier',
  templateUrl: './deactivate-supplier.component.html',
  styleUrls: ['./deactivate-supplier.component.css']
})
export class DeactivateSupplierComponent implements OnInit {
supplierId:string;
adminAction:number;
showBlackListedRequest:boolean;
showActivateRequest:boolean;
showDeactivateRequest:boolean;
  constructor(private route: ActivatedRoute,private supplierService: SupplierService,private alertService: AlertService,
    private translate: TranslateService) {
    this.supplierId = this.route.snapshot.params.Id;
    this.adminAction = this.route.snapshot.params.isDeactivate;



  }


  ngOnInit() {
    
    if(this.adminAction==SupplierAccountStatus.Activated){
      this.supplierService.ActivateSupplier(this.supplierId).subscribe(
        d=>{
            if(d.Success){
              this.showActivateRequest = true;
            }else{
              this.showActivateRequest = false;
              this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

            }
        }
      );
    }
    if(this.adminAction==SupplierAccountStatus.Disabled){
      this.supplierService.DeActivateSupplier(this.supplierId).subscribe(
        d=>{
          if(d.Success){
            this.showDeactivateRequest = true;
          }  else{
            this.showDeactivateRequest = false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

          }
        }
      );
    }
    if(this.adminAction == SupplierAccountStatus.BlackListed){
      this.supplierService.BlackListedSupplier(this.supplierId).subscribe(
        d=>{
          if(d.Success){
            this.showBlackListedRequest = true;
          }else{
            this.showBlackListedRequest = false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

          }
        }
      )
    }

  }

}
